import React from 'react'
import AdminFooter from '../../components/Admin/AdminFooter'

const AdminHome = () => {
  return (<>
    <div>AdminHome</div>
    <AdminFooter/>
    </>
  )
}

export default AdminHome